module.exports = __webpack_public_path__ + "img/73_9.af8e4aa2.png";